import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {validateEmail,isJsonString}  from 'util/Utils';
import config from  '../../../config';
import {makeRequest,displayMessage} from 'actions/index';
import _ from 'lodash';


import {Form, FormGroup, Col, ControlLabel,Checkbox, FormControl, Row, Button} from 'react-bootstrap';
import Select   from 'react-select';


export class AdminEmailPage extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            Body: "",
            Subject: "",
            currentRecord: "",
            FromName: "",
            FromEmail: "",
            allEmailRecords: [],
            KlaviyoTemplateData:'',
            testKlaviyoTemplate:false,
            emailAddress: 'info@goodbuygear.com',
            testPushNotificationAddress:'',
            kind: ''
        };
    }

    componentDidMount() {
        var addScript = document.createElement('script');
        addScript.setAttribute('src', 'https://cdn.ckeditor.com/4.7.3/standard/ckeditor.js');
        document.body.appendChild(addScript);
        this.getEmailRecords(true);
    }


    initializeCKeditor() {
        let configuration = {
            toolbar: "Basic",
            allowedContent: true,
            entities:false,
            fillEmptyBlocks:false,
            tabSpaces:0,
            extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*}'
        };
        CKEDITOR.replace("editor", configuration);
        CKEDITOR.instances.editor.on("change", function () {
            let data = CKEDITOR.instances.editor.getData();
            console.log('data in editor', data  );
            this.setState({Body: data});
        }.bind(this));
    }

    setCkeditorValue(body) {
        CKEDITOR.instances.editor.setData(body);
    }

    getEmailRecords(initialLoad = false) {
        var self = this;
        let methodData = {
            'endpoint': '/emails',
        };
        return this.props.makeRequest({sortBy:'Type:1'}, methodData)
            .then((res) => {


                if (_.get(res.data, 'data')) {
                    var dataToUpdate = {
                        allEmailRecords: res.data.data,
                           ..._.pick(res.data.data[0], ['Body', 'Subject', 'FromName','KlaviyoTemplateID','KlaviyoTemplateData', 'FromEmail']),
                        currentRecord: res.data.data[0],
                    }
                    var dataToUpdate 
                    if (initialLoad){
                         dataToUpdate = {
                            allEmailRecords: res.data.data,
                            ..._.pick(res.data.data[0], ['Body', 'Subject', 'FromName','KlaviyoTemplateID','KlaviyoTemplateData', 'FromEmail']),
                            currentRecord: res.data.data[0],
                        }
                    } else{
                         dataToUpdate = {
                            allEmailRecords: res.data.data,
                        }
                    }
                   self.setState(dataToUpdate);
                   if (initialLoad) {
                        self.setState({ kind: this.getKindValue(dataToUpdate) });
                        self.initializeCKeditor();
                        self.setCkeditorValue(res.data.data[0].Body);
                    }
                }
            })
            .catch(err => {
            });
    }

    saveEmail() {
        let self = this;
        let dataToUpdate = _.pick(this.state, ['Body', 'Subject', 'FromName',  'FromEmail'])
        let error = false;
        let fieldsToCheck = ['Body', 'Subject', 'FromName', 'FromEmail'];
        let kind = this.state.kind;

        switch (kind) {
            case 'event':
                fieldsToCheck.push('KlaviyoTrackAPIEvent')
                break;
            case 'template':
                fieldsToCheck.push('KlaviyoTemplateID')
            break;
        }

        if (this.state.currentRecord.NotificationType == 'sms'){
            fieldsToCheck = ['Body']
            dataToUpdate['Body'] =  this.state.Body.replace(/<[^>]+>/g, '');
            dataToUpdate['Body']  = dataToUpdate['Body'].replace(/(\r\n|\n|\r)/gm, "");
        }
        _.forEach(fieldsToCheck, function (field) {
            if  (!self.state[field]) {
                error = field
            }
        });

        if (error) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorFieldRequired',
                'messageData': {'#1#': _.startCase(error)},
            });
            return;
        }
        if ((config.getEnvironmentName() == 'local' || !_.isUndefined(this.state.currentRecord.KlaviyoTemplateID)) && self.state['KlaviyoTemplateID']) {
            dataToUpdate['KlaviyoTemplateID'] = self.state['KlaviyoTemplateID']
            if (this.state.KlaviyoTemplateData){
               if( isJsonString(this.state.KlaviyoTemplateData ) ){
                if ( !_.isEmpty(JSON.parse(self.state['KlaviyoTemplateData']))){
                       dataToUpdate['KlaviyoTemplateData'] = JSON.parse(self.state['KlaviyoTemplateData'])
                   }
               }else{
                   return   this.props.displayMessage({
                       'messageType': 'warning',
                       'messageCode': 'Template data is not in valid JSON format',

                   });

               }
            }
        }

        dataToUpdate.id = this.state.currentRecord._id;

        switch (kind) {
            case 'template':
                dataToUpdate['NotificationCustomDataToUpdate'] = {
                    KlaviyoTrackAPIEvent: 'unset'
                }
            break;
            case 'event':
                dataToUpdate['NotificationCustomDataToUpdate'] = {
                    KlaviyoTrackAPIEvent: self.state['KlaviyoTrackAPIEvent']
                }
                dataToUpdate.KlaviyoTemplateID = 'unset'
            break;
            case 'manual':
                dataToUpdate['NotificationCustomDataToUpdate'] = {
                    KlaviyoTrackAPIEvent: 'unset'
                }                
                dataToUpdate.KlaviyoTemplateID = 'unset'
                break;
        }
        
        let methodData = {
            type: 'patch',
            endpoint: '/emails',
            messageData: {'#1#': 'Email'},
            messageCode: 'recordUpdated'
        }

        this.props.makeRequest(dataToUpdate, methodData).then(function (response) {
            this.getEmailRecords()
        }.bind(this));
    }

    sendTestEmail() {
        var self = this;
        var data = {
            emailAddress: this.state.emailAddress,
             type: this.state.currentRecord.Slug
        }
        if (this.state.testKlaviyoTemplate){
            if(! this.state.templateID){
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, specify template ID'
                });
            }
            data.templateID = this.state.templateID
            data.KlaviyoTemplateData = this.state.KlaviyoTemplateData,
                data.type = 'send_email_with_Klaviyo'
        }
        if (!validateEmail(data.emailAddress)) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Email is not valid'
            });
        }

        var methodData = {
            type: 'post',
            endpoint: '/emails-send',
            messageCode: 'Email is sent'
        }
        this.props.makeRequest(data, methodData).then(function (response) {

        }.bind(this));
    }
    sendPushNotification() {
         var data = {
             emailAddress: this.state.testPushNotificationAddress,
            type:  'test_push_notification'
        }
        if (!validateEmail(data.emailAddress)) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Email is not valid'
            });
        }

        var methodData = {
            type: 'post',
            endpoint: '/emails-send',
            messageCode: 'Request is sent'
        }
        this.props.makeRequest(data, methodData).then(function (response) {

        }.bind(this));
    }
    onTextFieldChange(field, currentItem) {
        this.setState({
            [field]: currentItem.target.value
        });

    }

    onSelectType(data, type) {
        var selectedType = _.find(this.state.allEmailRecords, function (item) {
            return item._id == _.get(data,'value')
        });
        this.setState({
            ..._.pick(selectedType, ['Body', 'Subject', 'FromName',  'FromEmail']),
            KlaviyoTemplateID:_.get(selectedType,'KlaviyoTemplateID',''),
            KlaviyoTrackAPIEvent:_.get(selectedType,'NotificationCustomData.KlaviyoTrackAPIEvent',''),
            templateID:_.get(selectedType,'KlaviyoTemplateID',''),
            testKlaviyoTemplate:_.get(selectedType,'KlaviyoTemplateID','') ? true:false,
            KlaviyoTemplateData:JSON.stringify(_.get(selectedType,'KlaviyoTemplateData',{}),undefined, 4),
            currentRecord: selectedType,
            kind: this.getKindValue(selectedType)
        });
        this.setCkeditorValue(selectedType.Body);
    }

    getKindValue(data) {  
        if (_.get(data,'NotificationCustomData.KlaviyoTrackAPIEvent'))
            return 'event'
        else if (data.KlaviyoTemplateID)
            return 'template'
        else return 'manual'
    }

    render() {

         return (
            <div className={'top20'}>
                <Row>
                    <Col xs={12} md={12} className="top10 pull-left pright0">
                        <Col xs={12} sm={7} md={6} className="bot10 pull-right  ">
                            <div className=" clearfix">
                            <Button style={{width: '180px'}} onClick={(e) => this.sendTestEmail()}
                                    className="pull-right btn btn-primary" type="button">
                                {_.get(this.state.currentRecord,'NotificationCustomData.KlaviyoTrackAPIEvent') ? 'Send test event' : 'Send test email'}                        </Button>

                                <FormControl type="email" style={{width: '200px'}} className="right15 pull-right"
                                         value={this.state.emailAddress}

                                         onChange={e => {
                                             console.log('val', e.target.value);
                                             this.setState({emailAddress: e.target.value})
                                         }}/>
                            </div>
                            {(this.state.kind == 'event') &&
                            <Checkbox style={{width: '180px', position: 'relative', top: 7}}
                                      className="top10 pull-right  "
                                      onChange={(e) => this.setState({testKlaviyoTemplate: !this.state.testKlaviyoTemplate})}
                                      checked={this.state.testKlaviyoTemplate} inline><span className=" left5">Use Klaviyo template</span></Checkbox>
                            }
                            {(this.state.kind == 'template' || this.state.testKlaviyoTemplate) &&
                            <div className="top10">
                                {(this.state.kind == 'template') &&
                                <FormControl className="right15 pull-right bot10" style={{width: '200px'}}
                                             value={this.state.templateID}
                                             placeholder='Template ID'
                                             onChange={e => {
                                                 this.setState({templateID: e.target.value})
                                             }}/>
                                }
                            <FormControl componentClass="textarea" className="pull-right" style={{width: '395px'}} rows="8"
                                         value={this.state.KlaviyoTemplateData}
                                         placeholder="Email data"
                                         onChange={e => {
                                             this.setState({KlaviyoTemplateData: e.target.value})
                                         }}/>

                                </div>
                            }

                        </Col>

                        <Col xs={12} sm={6} md={6} className=" pull-left pleft0">
                            <Select
                                value={this.state.currentRecord._id}
                                clearable={false}
                                placeholder=""
                                options={_.orderBy(_.map(this.state.allEmailRecords, item => {

                                    return {value: item._id, NotificationType: item.NotificationType,  label: item.Type + (item.KlaviyoTemplateID ? ' Klaviyo':'') +  (_.get(item,'NotificationCustomData.KlaviyoTrackAPIEvent') ? ' Event':'')};
                                }),['NotificationType','label'], ['asc', 'asc'])}

                                onChange={ this.onSelectType.bind(this)}/>
                        </Col>

                    </Col>

                    <Col xs={12} md={12} className="top10 pright0">
                        <Col xs={12} sm={7} md={6} className="bot10 pull-right  ">
                            <Button style={{width: '180px'}} onClick={(e) => this.sendPushNotification()}
                                    className="pull-right btn btn-primary" type="button">
                                Send push notification
                            </Button>
                            <FormControl type="email" style={{width: '200px'}} className="right15 pull-right"
                                         value={this.state.testPushNotificationAddress}

                                         onChange={e => {
                                              this.setState({testPushNotificationAddress: e.target.value})
                                         }}/>

                        </Col>
                        <Col className="pull-left align-text-left pleft0" componentClass={ControlLabel} xs={12}
                             sm={2} md={2}>
                            Kind
                        </Col>
                        <Col xs={12} sm={4} md={4} className="pleft0">
                            <Select
                                    value={this.state.kind}
                                    clearable={false}
                                    placeholder=""
                                    options={[
                                        { label: 'Manual', value: 'manual' },
                                        { label: 'Template', value: 'template' },
                                        { label: 'Event', value: 'event' }
                                    ]}
                                    onChange={ e => { this.setState({ kind: e.value }) }}/>
                        </Col>
                    </Col>

                    <Col xs={12} md={12} className="top10 pright0">
                        <Col className="pull-left align-text-left pleft0" componentClass={ControlLabel} xs={12} sm={2} md={2}>
                            Subject
                        </Col>
                        <Col xs={12} sm={4} md={4} className="pleft0">
                            <FormControl type="text" value={this.state.Subject}
                                         onChange={this.onTextFieldChange.bind(this, "Subject")}/>
                        </Col>
                    </Col>
                    <Col xs={12} md={12} className="top10 pright0">
                        <Col className="align-text-left pleft0 pright0" componentClass={ControlLabel} xs={12} sm={2}
                             md={2}>
                            From Name
                        </Col>
                        <Col xs={12} sm={4} md={4} className="pleft0">
                            <FormControl type="text" value={this.state.FromName}
                                         onChange={this.onTextFieldChange.bind(this, "FromName")}/>
                        </Col>
                    </Col>
                    <Col xs={12} md={12} className="top10 pright0">
                        <Col className="align-text-left pleft0 pright0" componentClass={ControlLabel} xs={12} sm={2}
                             md={2}>
                            From Email
                        </Col>
                        <Col xs={12} sm={4} md={4} className="pleft0">
                            <FormControl type="text" value={this.state.FromEmail}
                                         onChange={this.onTextFieldChange.bind(this, "FromEmail")}/>
                        </Col>
                    </Col>
                        {(this.state.kind == 'template') &&
                        <Col xs={12} md={12} className="top10 pright0">
                            <Col className="pull-left align-text-left pleft0" componentClass={ControlLabel} xs={12}
                                 sm={2} md={2}>
                                Klaviyo Template ID
                            </Col>
                            <Col xs={12} sm={4} md={4} className="pleft0">
                                <FormControl type="text" value={this.state.KlaviyoTemplateID}
                                             onChange={this.onTextFieldChange.bind(this, "KlaviyoTemplateID")}/>
                            </Col>
                        </Col>
                        }
                    {(this.state.kind == 'event') &&
                    <Col xs={12} md={12} className="top10 pright0">
                        <Col className="pull-left align-text-left pleft0" componentClass={ControlLabel} xs={12}
                             sm={2} md={2}>
                            Klaviyo Track API Event
                        </Col>
                        <Col xs={12} sm={4} md={4} className="pleft0">
                            <FormControl type="text" value={ this.state.KlaviyoTrackAPIEvent}
                                         onChange={this.onTextFieldChange.bind(this, "KlaviyoTrackAPIEvent")}/>
                        </Col>
                    </Col>
                    }
                    <Col xs={12} md={12} className="top20 editor-wrapper ">
                        <textarea name="editor" cols="150" rows="16" defaultValue={this.state.Body}></textarea>
                    </Col>
                </Row>

                <Row className="top20">
                    <FormGroup className="top20 pull-right pright15">
                        <Button onClick={(e) => this.saveEmail()}
                                className="pull-right btn btn-primary" type="button">
                            Save
                        </Button>
                    </FormGroup>
                </Row>



            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return state
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, displayMessage}, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(AdminEmailPage);
